module.exports = __webpack_public_path__ + "static/media/icona storico versamenti.7ad8e0f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icona storico versamenti.png
// module id = 99
// module chunks = 0